import { Network } from 'turbos-clmm-sdk';
import { type Config } from './mainnet';
import testnet from './testnet';

const development: Config = {
  ...testnet,
  sui_network: Network.devnet,
  rpc: {
    sui_Official: 'https://fullnode.testnet.sui.io:443',
    shinami: 'https://api.shinami.com/node/v1/sui_testnet_60d3c675a6d403e634a0a04c2101a6bc',
  },
  burn_package_id: '0x3526c88f5304c78fb93ed1cc1961d56b8517108550c9938b8a5a0e6c90fbe2a5',
  fun: {
    originPackageId: '0xfda4d4e6b103f819e6b73c825e82e17cac3ee8384fb8409dd9e9f5e6c192506b',
    packageId: '0xfda4d4e6b103f819e6b73c825e82e17cac3ee8384fb8409dd9e9f5e6c192506b',
    globalConfig: '0xc85cbb029e8ce99e711181dfe8e97fbd6887c4c67940d4100ad0ea847659eeeb',
    configuration: '0x7ad47684dae004a821db664060e25746169b7cf76bf67fa4013b4feffeaaa1db',
    bytecodeBase64:
      'oRzrCwYAAAAKAQAMAgweAyonBFEIBVlXB7ABzAEI/AJgBtwDKwqHBAUMjAQsABABCwIGAhECEgITAAICAAEBBwEAAAIADAEAAQIDDAEAAQQEAgAFBQcAAAkAAQABDwUGAQACBwgJAQIDDAUBAQwDDQ4BAQwEDgsMAAUKAwQAAQQCBwMKBA0CCAAHCAQAAgsCAQgACwMBCAABCgIBCAUBCQABCwEBCQABCAAHCQACCgIKAgoCCwEBCAUHCAQCCwMBCQALAgEJAAELAgEIAAEGCAQBBQELAwEIAAIJAAUMQ29pbk1ldGFkYXRhBk9wdGlvbghURU1QTEFURQtUcmVhc3VyeUNhcAlUeENvbnRleHQDVXJsBGNvaW4PY3JlYXRlX2N1cnJlbmN5C2R1bW15X2ZpZWxkBGluaXQVbmV3X3Vuc2FmZV9mcm9tX2J5dGVzBm9wdGlvbhRwdWJsaWNfZnJlZXplX29iamVjdA9wdWJsaWNfdHJhbnNmZXIGc2VuZGVyBHNvbWUIdGVtcGxhdGUIdHJhbnNmZXIKdHhfY29udGV4dAN1cmwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICAQYKAgcGU1lNQk9MCgIFBE5BTUUKAgwLREVTQ1JJUFRJT04KAgQDVVJMAAIBCAEAAAAAAhQLAAcABwEHAgcDBwQRBjgACgE4AQwCDAMLAjgCCwMLAS4RBTgDAgA=',
  },
};

export default development;
